module.exports = {
	extends: [
		'/',
		'templates',
		'propertiesForms',
		'componentDataForm'
	],

	methods: {
		prepare: function(){
			if(this.config.useCase === 'removeMassProperties'){
				var c, g, f, group, field, modelField, dataType;
				for(c in (this.formMapping || {}).cols || []){
					for(g in (this.formMapping.cols[c] || [])){
						group = this.formMapping.cols[c][g] || {};
						if(group.fields){
							for(f in group.fields || []){
								field = group.fields[f] || {};
								if(field.modelFieldIndex !== undefined && (modelField = this.model.fields[field.modelFieldIndex])){
									if(!((modelField.config || {}).keepMultiSelectOnMassSubscribersRemoveProperties)){
										if(!field.fieldConfig) field.fieldConfig = {};
										field.fieldConfig.fieldPath = 'templates/newsletter/subscribers/fields/removePropertyToggle';
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
